import React from 'react';
import { saveAs } from 'file-saver';
import ExcelJS from 'exceljs';

const ExcelExport = ({ data, fileName }) => {
    const headers = [
        'S.No', 'Channel', 'Client', 'Project', 'Meter', 'Meter Type',
        'Meter Price', 'Description', 'Status'
    ];

    // Function to map data to headers
    const mapDataToHeaders = (data) => {
        return data.map((item, index) => {
            return {
                'S.No': index + 1,
                'Channel': item.channel || '',
                'Client': item.client || '',
                'Project': item.project || '',
                'Meter': item.meter || '',
                'Meter Type': item.meter_type === '1' ? 'Hourly' : 'Fixed', 
                'Meter Price': item.price || '',
                'Description': item.description || '',
                'Status': item.status === '1' ? 'Active' : 'Inactive',
            };
        });
    };

    const exportToExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet(`${fileName}`);

        // To apply border style
        const applyBorder = (cell) => {
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
        };

        // Define color and pattern for header
        const headerColor = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '8ea5e8' }
        };

        // Add header row with styling
        const headerRow = worksheet.addRow(headers);
        headerRow.font = { size: 10, bold: true };
        headerRow.alignment = { horizontal: 'center' };
        headerRow.height = 30;

        // Apply header color to columns A-I
        for (let i = 1; i <= 9; i++) {
            const cell = worksheet.getCell(1, i);
            cell.fill = headerColor;
            applyBorder(cell);
        }

        if (data.length === 0) {
            worksheet.mergeCells('A2:I2');
            const cell = worksheet.getCell('A2');
            cell.value = 'No Data Found';
            cell.alignment = { horizontal: 'center' };
            applyBorder(cell);
        } 
        else {
            const mappedData = mapDataToHeaders(data);
            mappedData.forEach(row => {
                const excelRow = worksheet.addRow(headers.map(header => row[header]));
                excelRow.eachCell({ includeEmpty: true }, cell => {
                    applyBorder(cell);
                });
            });
        }

        // Auto adjust column widths
        worksheet.columns.forEach((column) => {
            let maxLength = 0;
            column.eachCell({ includeEmpty: true }, cell => {
                if (cell.value && cell.value.toString().length > maxLength) {
                    maxLength = cell.value.toString().length;
                }
            });
            column.width = maxLength + 2;
        });

        // Save the workbook
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/octet-stream' });
        saveAs(blob, `${fileName}.xlsx`);
    };

    return (
        <button className="btn btn-secondary" onClick={exportToExcel}>
            <i className="fa fa-file-excel"></i> &nbsp; Export to Excel</button>
    );
}

export default ExcelExport;
